import {
    SAVE_SITE_AGGR_STATS_GRAPH,
    SITE_AGGR_STATS_GRAPH_API_LOADING,
} from '../../constants/graphConstants/customerAggrStatsGraphConstants';

/**
 * Reducer function for managing site graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const siteAggrStatsReducer = (state = {
    loading: false, 
    stats : {},
}, action) => {
	switch (action.type) {
		case SAVE_SITE_AGGR_STATS_GRAPH:
            return {
                ...state, 
                loading: false, 
                ...action.payload  
            };
        case SITE_AGGR_STATS_GRAPH_API_LOADING:
            return { 
                ...state,
                stats : {},
                loading: action.payload, 
            };
		default:
			return state;
	}
};